@use "../../styles/breakpoint.module.scss" as *;

.root {
    font: var(--font-eyebrow-14);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    border-block: 1px solid var(--gray-500);
}

.carouselContainer {
    position: relative;
}

.slideWrapper {
    display: flex;
}

.list {
    composes: container from "../../styles/composable/layout.module.css";

    &:focus-visible {
        outline: var(--outline);
        outline-offset: 1px;
    }
}

.listItem {
    width: max(33.333%, calc(100% / var(--item-count)));
    flex-shrink: 0;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-height: 100px;
    padding-block: var(--spacer-16);
    padding-inline: calc(var(--grid-gap) / 2);
    border-right: 1px solid var(--gray-500);
    color: var(--color-contrast);
    text-align: center;
    transition: border-color 0.2s;
    overflow-y: hidden;

    @media ($below-mobile) {
        width: 100%;
        min-height: 62px;
        padding-inline: calc(var(--spacer-40) + var(--spacer-24));
        border-right-color: transparent;
    }

    // If this component ever gets capped at three value props, most of this
    // can go away
    @media ($above-mobile) {
        // :last-child is redundant but prevents a flash of styling in normal
        // use cases.
        &[data-last-visible="true"],
        &:last-child {
            border-right-color: transparent;
        }

        // If we're on a desktop on carousel, which is only possible when there
        // are more than three value props, make some space for the arrows.
        [data-carousel-all-visible="false"] & {
            &[data-first-visible="true"] {
                padding-left: var(--spacer-32);
            }

            &[data-last-visible="true"] {
                padding-right: var(--spacer-32);
            }
        }
    }
}

.controls {
    position: absolute;
    top: 50%;
    inset-inline: var(--labui-container-margin);
    transform: translateY(-50%);
    z-index: 2;
    display: flex;
    justify-content: space-between;
}

.arrow {
    width: var(--spacer-40);
    height: var(--spacer-40);

    svg {
        display: block;
        width: 75%;
        height: 75%;
        fill: var(--color-contrast);
        // moves the arrow to the edge of the button and the grid
        transform: translateX(60%);
    }
}

.arrowLeft {
    composes: arrow;
    scale: -1;
}

.arrowRight {
    composes: arrow;
}
